var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHaxeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC707",
    d: "M128 60.5008L76.7392 54.8236L38 38H82.9984L128 60.5038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC707",
    d: "M128 60.5008L180.435 55.9975L218 38H172.998L128 60.5038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F68712",
    d: "M128 195.502L176.913 197.263L218 218.003H172.998L128 195.498"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F25C19",
    d: "M128 195.502H78.6957L38 218.003H82.9984L128 195.498"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF200",
    d: "M60.4992 128.002V175.349L38 218.003V173.003L60.4992 128.001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF200",
    d: "M60.4992 128.002L56.7825 81.0418L38 38V82.9995L60.4992 128.001"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1471D",
    d: "M195.497 128.002L200.391 78.6939L218 38V82.9995L195.497 128.001"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1471D",
    d: "M195.497 128.002L199.609 180.828L218 218.003V173.003L195.497 128.001"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB20B",
    d: "M38 38L128 60.5008L113.522 117.826L60.4992 128.002L38 38.0048"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F47216",
    d: "M218 38L195.497 128.002L135.043 117.04L128 60.498L218 38.0048"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F25C19",
    d: "M218 218.003L128 195.502L138.174 135.831L195.497 128.007L218 217.997"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F89C0E",
    d: "M38 218.003L60.4992 128.002L114.696 140.131L128 195.502L38 217.997"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F68712",
    d: "M128 60.5008L60.4993 128.002L128 195.502L195.497 128.002L128 60.5038"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaxeDark);
export default __webpack_public_path__ + "static/media/Haxe-Dark.f8260e4917a65b9cc5bf4dc768c0872b.svg";
export { ForwardRef as ReactComponent };